export const en = {
    cancel: 'Cancel',
    down: 'decrease',
    error: 'You can not {change} the bid by more than {percent}%',
    max: 'max',
    min: 'min',
    'rate-string': '{change} bid by {percent}%',
    save: 'OK',
    up: 'increase'
};
